module.exports = __webpack_public_path__ + "ec27e8d9f838f3b66ac82375a176f281.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-14.png
// module id = 1457
// module chunks = 0